import {
  fieldTypeDistanceReport,
  pointTypeEnum,
  typeDistanceReport,
  TypeRequestReportRouteEnum
} from '@/modules/neodash/pages/nearestReports/types';
import {NameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {FilterOldService} from '@/modules/neodash/services/filterOldService';
import {store} from '@/modules/neodash/model/types/interfaces/Stores';
import {NearestReportService} from '@/modules/neodash/pages/nearestReports/nearestReport.service';

const fromStoreFields: fieldTypeDistanceReport<store>[] = [
  {title: 'Common.Id', getter: x => x.codStoreClient},
  {title: 'Common.Name', getter: x => x.name},
  {title: 'Common.Group', getter: x => x.group}
];

const fromCityFields: fieldTypeDistanceReport<NameValue>[] = [
  {title: 'Common.Name', getter: x => x.name},
];

const getStores = FilterOldService.getStores;
const getCities = FilterOldService.getLocations;

const typeReportsFromStore: typeDistanceReport<store>[] = [
  {
    type: TypeRequestReportRouteEnum.storeToStore,
    to: pointTypeEnum.store,
    from: pointTypeEnum.store,
    fields: fromStoreFields,
    getOriginData: getStores,
    downloadReport: obj => NearestReportService.getReportStoreToStores(obj.id, obj.name)
  },
  {
    type: TypeRequestReportRouteEnum.storeToOperationAreas,
    to: pointTypeEnum.operationalArea,
    from: pointTypeEnum.store,
    fields: fromStoreFields,
    getOriginData: getStores,
    downloadReport: obj => NearestReportService.getReportStoreToOperationalAreas(obj.id, obj.name)
  },
];

const typeReportsFromCity: typeDistanceReport<NameValue>[] = [
  {
    type: TypeRequestReportRouteEnum.cityToStore,
    to: pointTypeEnum.store,
    from: pointTypeEnum.city,
    fields: fromCityFields,
    getOriginData: getCities,
    downloadReport: obj => NearestReportService.getReportCityToStores(obj.value, obj.name)
  },
  {
    type: TypeRequestReportRouteEnum.cityToOperationAreas,
    to: pointTypeEnum.operationalArea,
    from: pointTypeEnum.city,
    fields: fromCityFields,
    getOriginData: getCities,
    downloadReport: obj => NearestReportService.getReportCityToOperationalAreas(obj.value, obj.name)
  },
];

export const typeReports: typeDistanceReport<any>[] = [...typeReportsFromCity, ...typeReportsFromStore];
